document.getElementById('pincodeInputId').addEventListener('input', function () {
  // Allow only numbers
  this.value = this.value.replace(/[^0-9]/g, '');

  const enteredPincode = this.value.trim();
  const addressResult = document.querySelector('.address-result');
  const noResultMessage = document.getElementById('no-result-message');
  const validationMessage = document.getElementById('validation-message');

  if (enteredPincode === '') {
    addressResult.style.display = 'none';
    noResultMessage.style.display = 'none';
    validationMessage.style.display = 'none'; // Hide validation message when input is cleared
  }
});

// Event listener for button click
document.getElementById('check_pincode').addEventListener('click', function () {
  const enteredPincode = document.getElementById('pincodeInputId').value.trim();
  const sku = document.getElementById('sku').value.trim();
  const validationMessage = document.getElementById('validation-message');
  const addressList = document.querySelectorAll('.address-result ul li');
  const addressResult = document.querySelector('.address-result');
  const noResultMessage = document.getElementById('no-result-message');

  // Validation: Show message if input is empty
  if (enteredPincode === '') {
    validationMessage.style.display = 'inline';
    validationMessage.textContent = 'Please enter a pincode.';
    addressResult.style.display = 'none';
    noResultMessage.style.display = 'none';
    return;
  } else {
    validationMessage.style.display = 'none'; // Hide validation message if input is not empty
  }
 // alert("ready to send info to Server");
  //send pincode to server to get nearest store location
    var data = {
        action: "store_availability",
        pincode: enteredPincode,
        sku: sku
      };
      //console.log(data);
      // AJAX POST request
      fetch("https://www.wp-themes.in/api/store/get", {
  method: "POST",
  headers: {
    "Content-Type": "application/json"
  },
  body: JSON.stringify(data)
})
.then(response => {
  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }
  return response.text(); // Expecting HTML
})
.then(html => {
  const addressResultDiv = document.querySelector(".address-result");
  if (addressResultDiv) {
    addressResultDiv.innerHTML = html;
    addressResultDiv.style.display = "block"; // Make sure it's visible
  }
})
.catch(error => {
  console.error("Error loading HTML content:", error);
});


  //end


  
 
});